import React from 'react';
import { NostoContext } from './Provider';
export const NostoElementContext = React.createContext(null);
class NostoElement extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            data: null
        };
    }
    componentDidMount() {
        this.context.registerElement(this.props.id);
        this.context.addEventListener('postrender', (event) => {
            const data = event.responseData[this.props.id];
            if (data) {
                try {
                    // Nosto adds a anchor tag in the title of their preview data which is not valid JSON. This filters that out.
                    const strippedData = data.replace(/<a href(.*)>(.*)<\/a>/, '');
                    this.setState({
                        data: JSON.parse(strippedData)
                    });
                }
                catch (e) {
                    console.error('Failed to parse Nosto data', data);
                    this.setState({
                        data: null
                    });
                }
            }
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.context.unregisterElement(prevProps.id);
            this.context.registerElement(this.props.id);
        }
    }
    componentWillUnmount() {
        this.context.unregisterElement(this.props.id);
    }
    render() {
        return (React.createElement(NostoElementContext.Provider, { value: this.props.id },
            React.createElement("span", { style: { display: 'none' } },
                React.createElement("span", { className: "nosto_element", id: this.props.id })),
            this.props.children(this.state.data)));
    }
}
NostoElement.contextType = NostoContext;
export default NostoElement;
//# sourceMappingURL=Element.js.map